"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _sampleContacts = require("crm_ui/constants/sampleData/sampleContacts");

var _makeCallLogSampleTimelineEvent = _interopRequireDefault(require("crm_ui/utils/sampleData/makeCallLogSampleTimelineEvent"));

var _makeMeetingSampleTimelineEvent = _interopRequireDefault(require("crm_ui/utils/sampleData/makeMeetingSampleTimelineEvent"));

var _makeTaskSampleTimelineEvent = _interopRequireDefault(require("crm_ui/utils/sampleData/makeTaskSampleTimelineEvent"));

var _makeEmailLogSampleTimelineEvent = _interopRequireDefault(require("crm_ui/utils/sampleData/makeEmailLogSampleTimelineEvent"));

var _makeEmailOpenSampleTimelineEvent = _interopRequireDefault(require("crm_ui/utils/sampleData/makeEmailOpenSampleTimelineEvent"));

var _UserStore = _interopRequireDefault(require("crm_data/user/UserStore"));

var USER_FIRSTNAME = _UserStore.default.get('first_name');

var sampleTimelineEvents = {
  BRIAN: [(0, _makeMeetingSampleTimelineEvent.default)({
    inviteeEmails: [_sampleContacts.BRIAN.CONTACT_EMAIL],
    title: _I18n.default.text('sampleData.sampleTimelineEvents.brian.sampleMeeting.title'),
    body: _I18n.default.text('sampleData.sampleTimelineEvents.brian.sampleMeeting.body'),
    endTime: _I18n.default.moment().add(3, 'days').valueOf(),
    startTime: _I18n.default.moment().add(3, 'days').valueOf()
  }), (0, _makeTaskSampleTimelineEvent.default)({
    title: _I18n.default.text('sampleData.sampleTimelineEvents.brian.sampleTask.title'),
    body: _I18n.default.text('sampleData.sampleTimelineEvents.brian.sampleTask.body')
  }), (0, _makeCallLogSampleTimelineEvent.default)({
    body: _I18n.default.text('sampleData.sampleTimelineEvents.brian.sampleCallNote.body')
  }), (0, _makeEmailOpenSampleTimelineEvent.default)({
    created: _I18n.default.moment().subtract(1, 'days').valueOf(),
    subject: _I18n.default.text('sampleData.sampleTimelineEvents.brian.sampleEmail.subject'),
    sources: [{
      domain: 'hubspot.com',
      email: _sampleContacts.BRIAN.CONTACT_EMAIL,
      name: _sampleContacts.BRIAN.CONTACT_FIRST_NAME + " " + _sampleContacts.BRIAN.CONTACT_LAST_NAME
    }]
  }), (0, _makeEmailLogSampleTimelineEvent.default)({
    subject: _I18n.default.text('sampleData.sampleTimelineEvents.brian.sampleEmail.subject'),
    html: _I18n.default.text('sampleData.sampleTimelineEvents.brian.sampleEmail.body', {
      userFirstName: USER_FIRSTNAME
    }),
    toEmail: _sampleContacts.BRIAN.CONTACT_EMAIL,
    toFirstName: _sampleContacts.BRIAN.CONTACT_FIRST_NAME,
    toLastName: _sampleContacts.BRIAN.CONTACT_LAST_NAME,
    created: _I18n.default.moment().subtract(2, 'days').valueOf()
  })],
  COOL_ROBOT: [(0, _makeMeetingSampleTimelineEvent.default)({
    inviteeEmails: [_sampleContacts.COOL_ROBOT.CONTACT_EMAIL],
    title: _I18n.default.text('sampleData.sampleTimelineEvents.coolRobot.sampleMeeting.title'),
    body: _I18n.default.text('sampleData.sampleTimelineEvents.coolRobot.sampleMeeting.body'),
    endTime: _I18n.default.moment().add(3, 'days').valueOf(),
    startTime: _I18n.default.moment().add(3, 'days').valueOf()
  }), (0, _makeTaskSampleTimelineEvent.default)({
    title: _I18n.default.text('sampleData.sampleTimelineEvents.coolRobot.sampleTask.title'),
    body: _I18n.default.text('sampleData.sampleTimelineEvents.coolRobot.sampleTask.body')
  }), (0, _makeCallLogSampleTimelineEvent.default)({
    body: _I18n.default.text('sampleData.sampleTimelineEvents.coolRobot.sampleCallNote.body')
  }), (0, _makeEmailOpenSampleTimelineEvent.default)({
    created: _I18n.default.moment().subtract(1, 'days').valueOf(),
    subject: _I18n.default.text('sampleData.sampleTimelineEvents.coolRobot.sampleEmail.subject'),
    sources: [{
      domain: 'hubspot.com',
      email: _sampleContacts.COOL_ROBOT.CONTACT_EMAIL,
      name: _sampleContacts.COOL_ROBOT.CONTACT_FIRST_NAME + " " + _sampleContacts.COOL_ROBOT.CONTACT_LAST_NAME
    }]
  }), (0, _makeEmailLogSampleTimelineEvent.default)({
    subject: _I18n.default.text('sampleData.sampleTimelineEvents.coolRobot.sampleEmail.subject'),
    html: _I18n.default.text('sampleData.sampleTimelineEvents.coolRobot.sampleEmail.body', {
      userFirstName: USER_FIRSTNAME
    }),
    toEmail: _sampleContacts.COOL_ROBOT.CONTACT_EMAIL,
    toFirstName: _sampleContacts.COOL_ROBOT.CONTACT_FIRST_NAME,
    toLastName: _sampleContacts.COOL_ROBOT.CONTACT_LAST_NAME,
    created: _I18n.default.moment().subtract(2, 'days').valueOf()
  })]
};
var _default = sampleTimelineEvents;
exports.default = _default;
module.exports = exports.default;